module.exports = __webpack_public_path__ + "6b4d67819.png";